import React from 'react';
import * as RT from '../../../constants/Routing';

import DetailCommunity from '../Detail'
import { Redirect } from 'react-router-dom';
export default class Component extends React.Component {

  componentWillMount = () => {
    if (!this.props.Community.community || Number(this.props.Community.community.id) !== Number(this.props.match.params.id)) {
      this.props.communityGet(this.props.match.params.id)
    }
  }
  
  componentWillUnmount = (i, e, u) => {
    if (this.props.history.location.pathname !== RT.COMMUNITY_POSTS_PATH.replace(/:id/,this.props.match.params.id)) {
      this.props.communityInfoRemove()
    }
  }

  render = () => {
    const currentUser = this.props.App.currentUser
    const selectedCommunity = this.props.Community.community
    const currentPath = this.props.router.location.pathname

    if (selectedCommunity === false) {
      return (
        <Redirect to={RT.USER_MYPAGE_PATH} />
      )
    }

    return (
      <DetailCommunity
        currentUser={currentUser}
        currentPath={currentPath}
        circle={selectedCommunity}
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Community/Show/Show.jsx